export const SET_REFRESH_TOKEN_FAILED = 'SET_REFRESH_TOKEN_FAILED';
